import React from 'react'

import { getDayOfWeek } from '../../../helpers'

const WeekHeader = ({ date }) => {
  const day = getDayOfWeek(date)
  const monthDate = date.getDate()
  const month = date.getMonth()

  return (
    <div className="flex flex-col w-full">
      <b className="text-sm font-semibold text-primary-100">{day}</b>

      <span className="text-xs font-normal text-primary-100 leading-[18px]">
        {monthDate}/{month}
      </span>
    </div>
  )
}

export default WeekHeader
